import Urls from "./Urls";


function StringIsNull(data: string) {
    if (data == undefined || data == null || data.length == 0) { return true; }
    return false;
}
function ConsoleLog(data: any) {
    console.log(data);
}
function GetGuid() {
    let guid = "";
    for (let i = 1; i <= 32; i++) {
        const n = Math.floor(Math.random() * 16.0).toString(16);
        guid += n;
        if (i == 8 || i == 12 || i == 16 || i == 20) guid += "-";
    }
    return guid;
}
function GetPageReq(page: number, pageSize: number, search?: any, fileds?: string[], condition?: number,deviceTypeSid?:string): any {
    const req: any = {
        page: page,
        pageSize: pageSize,
        conditions: []
    }
    if(!search||!fileds||fileds.length==0)
    {
        return req;
    }
    
    if(deviceTypeSid){
        req.conditions.push({
            field:"deviceTypeSid",
            value:deviceTypeSid,
            conditionType:0,
            andCondition:true
        })
    }
    if(search&& typeof search==="string"){
        fileds.forEach(x => {
            let ctype= condition == undefined ? 7 : condition;
            if(x=='deviceTypeSid'){
                ctype=0;
            }
            req.conditions.push({
                    field: x,
                    value: search.trim(),
                    conditionType:ctype
                })
        })
        return req;
    }
    console.log("test");
    if(search["online"]==undefined){
        //
    }else{
        if(search.online!=2){
            req.conditions.push({
                field: "online",
                value: search.online+"",
                conditionType:0,
                andCondition:true
            })
        }
    }
    if(search["assetState"]==undefined){
        //
    }  else{
        if(search.assetState!=-1){
            req.conditions.push({
                field: "state",
                value: search.assetState+"",
                conditionType:0,
                andCondition:true
            })
        }
    }
    if(search["assetType"]==undefined){
        //
    }  else{
        if(search.assetState!=-1){
            req.conditions.push({
                field: "assetTypeSid",
                value: search.assetType+"",
                conditionType:0,
                andCondition:true
            })
        }
    }
    if(search["workType"]==undefined){
        //
    }  else{
        if(search.assetState!=-1){
            req.conditions.push({
                field: "workOrderTypeSid",
                value: search.workType+"",
                conditionType:0,
                andCondition:true
            })
        }
    }
    if(search["orderState"]==undefined){
        //
    }  else{
        if(search.assetState!=-1){
            req.conditions.push({
                field: "state",
                value: search.orderState+"",
                conditionType:0,
                andCondition:true
            })
        }
    }
    if(search&&search.searchStr){
        fileds.forEach(x => {
            let ctype= condition == undefined ? 7 : condition;
            if(x=='deviceTypeSid'){
                ctype=0;
            }
            req.conditions.push({
                    field: x,
                    value: search.searchStr.trim(),
                    conditionType:ctype
                })
        })
    }
    return req;
}
function FormatData(date: Date) {
    date = date || new Date();
    if (!date.getFullYear) {
        date = new Date();
    }
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = FixStart0( date.getHours());
    const minute = FixStart0( date.getMinutes());
    const second =FixStart0(  date.getSeconds());
    return [hour, ':', minute, ':', second].join('');
}
function FormatDataFull(date: Date) {
    if(!(date instanceof Date)){
        return date;
    }
    if (!date.getFullYear) {
        date = new Date();
    }
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = FixStart0( date.getHours());
    const minute = FixStart0( date.getMinutes());
    const second =FixStart0(  date.getSeconds());
    return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
}
function FixStart0(val:number){
    if(val>=10)
    {
        return val;
    }else{
        return `0${val}`;
    }
}
function GetBaseUrl() {
    return process.env.NODE_ENV == "production" ? "" : "http://localhost:5000"
    // return "https://xw.kingsunsmart.com";

}
function GetHomeInfo(){
    return {
        Name:"勤上光电智慧照明管理平台",
        Ipc:"粤ICP备17060943号",
        Prod:undefined,
        // Prod:"勤上光电股份有限公司"
    }
    // return {
    //     Name:"兴文县智慧城市管理平台",
    //     Ipc:"苏ICP备15040136号-1",
    //     Prod:"神州交通工程集团有限公司"
    // }
}
function GetPointerDistance(pointer1: any, pointer2: any) {
    const distance = Math.sqrt(Math.pow((pointer1.lng - pointer2.lng) * 100000, 2) + Math.pow((pointer1.lat - pointer2.lat) * 100000, 2));
    return Math.round(distance);
}
function GetAllDistance(pointers: any[]) {
    let distance = 0;
    for (let i = 0; i < pointers.length - 1; i++) {
        distance += GetPointerDistance(pointers[i], pointers[i + 1]);
    }
    return distance;
}
function GetNextPosition(pointers: any[], count: number) {
    const ret: any[] = [];
    const distance = GetAllDistance(pointers);
    for (let i = 0; i < pointers.length - 1; i++) {
        const dis = GetPointerDistance(
            pointers[i],
            pointers[i + 1]
        );
        const bit = dis / distance;
        const rcount = (count);
        const zcount = Math.round(bit * rcount);
        ret.push({
            lat: pointers[i].lat,
            lng: pointers[i].lng
        })
        const lat1 = pointers[i].lat * 100000;
        const lng1 = pointers[i].lng * 100000;
        const lng2 = pointers[i + 1].lng * 100000;
        const lat2 = pointers[i + 1].lat * 100000;
        const lat = lat1 - lat2;
        const latbit = lat / (zcount);
        for (let j = 0; j < zcount - 1; j++) {
            let xvalue=0;
            if(lat1<lat2){
                xvalue = (lat1 - (latbit * (j + 1))) / 100000;
            }else{
                xvalue = (lat1 - (latbit * (j + 1))) / 100000;
            }
            const yvalue = GetYByX(pointers[i], pointers[i+1], xvalue);
            ret.push({
                lat: xvalue,
                lng: yvalue
            });
        }
    }
    return ret;
}
function GetYByX(pointerStart: any, pointerEnd: any, xvalue: number) {
    return ((xvalue - pointerEnd.lat) * (pointerStart.lng - pointerEnd.lng) / (pointerStart.lat - pointerEnd.lat)) + pointerEnd.lng;
}
function ConfirmMsg(vue:any,title:string,action:any,errorAction?:any){
    vue.$confirm(title,"提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
    }).then(()=>{
        action();
    }).catch(()=>{
        if(errorAction){
            errorAction();
        }
        // vue.$message({
        //     type:"info",
        //     message:"已经取消操作"
        // })
    })
}
function PointerInPolygon(data:any[],pointer:any){
    let j=data.length-1;
    let oddNodes=false;
    for(let i=0;i<data.length;i++){
        if((data[i].lng<pointer.lng&&data[j].lng>=pointer.lng)||(data[j].lng<pointer.lng&&data[i].lng>=pointer.lng)
        ){
            if(data[i].lat+(pointer.lng-data[i].lng)/(data[j].lng-data[i].lng)*(data[j].lat-data[i].lat)<pointer.lat){
                oddNodes=!oddNodes;
            }
        }
        j=i;
    }
    return oddNodes;
}
function ArrayGroupBy(array:any[],f:any){
    const groups:any={};
    array.forEach((x:any)=>{
        const group=f(x);
        groups[group]=groups[group]||[];
        groups[group].push(x);
    });
    return groups;
}
function getTran(){
    return true;
}
function getHidenTitle(){
    return false;
}
function getDefalutPageSize(){
    return 30;
}
function getActionUrl(path:string){
    console.log(path,"testtest");
    let data:any=null;
    let lable1:any=null;
    let lable2:any=null;
    path=path.toLocaleLowerCase();
    if(path.startsWith("/home/dust/")||path=="5"){
        data="dust";
        lable1="PM2.5(μg/m³)"
        lable2="PM10(μg/m³)"
    }
    if(path.startsWith("/home/dustcar/")||path=="10"){
        data="dirtycar"
    }
    if(path.startsWith("/home/voice/")||path=="6"){
        data="noise"
        lable1="噪音(分贝)"
    }
    if(path.startsWith("/home/fume/")||path=="13"){
        data="lampblack"
        lable1="油烟值(mg/m³)"
    }
    if(path.startsWith("/home/cover/")||path=="9"){
        data="manholecover"
        lable1="倾斜角度"
        lable2="满溢情况"
    }
    if(path.startsWith("/home/broad/")||path=="8"){
        data="broadcast"
    }
    if(path.startsWith("/home/envcar/")||path=="7"){
        data="sanitation"
        lable1="纬度"
        lable2="经度"
    }
    if(path.startsWith("/home/envcar/pointer")){
        data="SanitationPoint"
        lable1="纬度"
        lable2="经度"
    }
    if(path.startsWith("/home/bridge/")||path=="14"){
        data="BridgeMonitor"
        lable1="当前值"
    }
    if(data){
        return {
            delUrl:`/api/${data}/Delete`,
            getUrl:`/api/${data}/Get`,
            getListUrl:`/api/${data}/GetList`,
            updateUrl:`/api/${data}/Update`,
            addUrl:`/api/${data}/Add`,
            label1:lable1,
            label2:lable2
        }
    }
    return null;
}
function getCurrentSid(path:string) {
    let currentSid:any=null;
    path=path.toLocaleLowerCase();
    if(path.startsWith("/home/camra")){
        return "12";
    }
    if(path.startsWith("/home/dust/")){
        return "5";
    }
    if(path.startsWith("/home/voice")){
        return "6";
    }
    if(path.startsWith("/home/fume")){
        return "13";
    }
    if(path.startsWith("/home/broad")){
        return "8";
    }
    if(path.startsWith("/home/cover")){
        return "9";
    }
    if(path.startsWith("/home/envcar")){
        return "7";
    }
    if(path.startsWith("/home/dustcar")){
        return "12";
    }
    if(path.startsWith("/home/lsensor")){
        return "11";
    }
    if(path.startsWith("/home/bridge")){
        return "14";
    }
    switch (path) {
      case "/home/camra/oview":
        currentSid = "12";
        break;
      case "/home/dust/oview":
        currentSid = "5";
        break;
      case "/home/voice/oview":
        currentSid = "6";
        break;
      case "/home/fume/oview":
        currentSid = "13";
        break;
      case "/home/broad/oview":
        currentSid = "8";
        break;
      case "/home/cover/oview":
        currentSid = "9";
        break;
      case "/home/envcar/oview":
        currentSid = "7";
        break;
      case "/home/dustcar/oview":
        currentSid = "10";
        break;
      case "/home/lsensor/oview":
        currentSid = "11";
        break;
      default:
        currentSid = null;
        break;
    }
    return currentSid;
  }
  /**
 * 获取过去30天日期数组，格式 "YYYY/MM/DD HH:00"
 * @returns {string[]}
 */
function getPast30DayList() {
    const result = [];
    const now = new Date();
    for (let i = 29; i >= 0; i--) {
      const date = new Date(now);
      date.setDate(now.getDate() - i);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      // 固定小时12:00
      result.push(`${y}/${m}/${d}`);
    }
    return result;
  }
export default {
    getPast30DayList:getPast30DayList,
    getDefalutPageSize:getDefalutPageSize,
    StringIsNull: StringIsNull,
    ConsoleLog: ConsoleLog,
    GetPageReq: GetPageReq,
    GetGuid: GetGuid,
    FormatData: FormatData,
    GetBaseUrl: GetBaseUrl,
    GetPointerDistance: GetPointerDistance,
    GetAllDistance: GetAllDistance,
    GetNextPosition: GetNextPosition,
    ConfirmMsg:ConfirmMsg,
    PointerInPolygon:PointerInPolygon,
    ArrayGroupBy:ArrayGroupBy,
    FormatDataFull:FormatDataFull,
    getTran:getTran,
    getHidenTitle:getHidenTitle,
    getCurrentSid:getCurrentSid,getActionUrl:getActionUrl,
    GetHomeInfo:GetHomeInfo
}